export default __webpack_public_path__ + "static/media/infoIcon.8d605c80.svg";